/**
 * We have only ONE STORE consisting of multiple such `slices`.
 * Each slice is seperated out in a file.
 */
import { createStore } from 'zustand/vanilla';
import { devtools } from 'zustand/middleware';

//import multiple slices here and add it
import { createOnboardingState, OnboardingState } from './onboarding-slice';
import { createOrganisationState, OrganisationState } from './organisation-slice';
import { createUserState, UserState } from './user-slice';
import { createStoreState, StoreState } from './store-slice';
import { createWebsiteBuilderSlice, WebsiteBuilderSlice } from './website-builder-slice';

export type StoreType = UserState &
  OnboardingState &
  OrganisationState &
  StoreState &
  WebsiteBuilderSlice;

/**
 * This method is used in RSC + Context.Provider setup.
 */
export const createBoundStore = () => {
  return createStore<StoreType>()(
    devtools(
      (...a) => ({
        ...createOnboardingState(...a),
        ...createOrganisationState(...a),
        ...createUserState(...a),
        ...createStoreState(...a),
        ...createWebsiteBuilderSlice(...a)
      }),
      { name: 'MyZustandStore' }
    )
  );
};

export { useStore } from '@/providers/store-provider';
